import { OrderedList as OrderedListToExtend } from '@tiptap/extension-ordered-list';

export const OrderedList = OrderedListToExtend.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            class: {
                default: 'list-outside'
            },
            style: {
                default: null
            }
        }
    }
});
